import { BaseCrudService } from '../../common/services/base-crud.service';
import {
  Operator,
  OperatorDetail,
  OperatorForm,
  OperatorServicesPayload,
} from './models/operator.model';
import { environment } from '../../../environments/environment';
import { ApiItemResponse } from '../../common/models/api';
import { HttpParams } from '@angular/common/http';
import { OperatorDailyOrderStat } from './models/operator.model';

export interface OperatorSetPasswordPayload {
  operator: string;
  password: string | number;
}

export interface OperatorAdjustCostPayload {
  ledger: string;
  correctedAmount: number;
  description: string;
}

export class OperatorsService extends BaseCrudService<
  Operator,
  OperatorDetail,
  OperatorForm
> {
  protected resource: string = 'operators';
  protected apiRoot: string = environment.baseUrl;
  baseUrl: string = `${this.apiRoot}`;

  updateServices(id: string, payload: OperatorServicesPayload) {
    return this.http.patch<ApiItemResponse<OperatorDetail>>(
      `${this.apiRoot}/${this.resource}/${id}/services`,
      payload,
    );
  }

  updateAvailability(id: string, isAvailable: boolean) {
    return this.http.patch<ApiItemResponse<Operator>>(
      `${this.apiRoot}/${this.resource}/availability/${id}`,
      { isAvailable },
    );
  }

  acceptCardToCard(body: {
    paidUser: string;
    selectedCard: string;
    trackingCode: string;
    amount: number | string;
  }) {
    return this.http.post<ApiItemResponse<any>>(
      `${this.apiRoot}/${this.resource}/acceptCardToCard`,
      body,
    );
  }

  acceptOrder(orderId: string) {
    return this.http.patch<ApiItemResponse<Operator>>(
      `${this.apiRoot}/${this.resource}/accept/${orderId}`,
      {},
    );
  }

  addCost(orderId: string, amount: number, description: string | undefined, receipt: string) {
    return this.http.post<ApiItemResponse<Operator>>(
      `${this.apiRoot}/${this.resource}/addCost/`,
      {
        order: orderId,
        amount,
        description,
        receipt,
      },
    );
  }

  adjustCost(payload: OperatorAdjustCostPayload) {
    return this.http.post<ApiItemResponse<unknown>>(
      `${this.apiRoot}/${this.resource}/adjustCost`,
      payload,
    );
  }

  rejectOrder(orderId: string) {
    return this.http.patch<ApiItemResponse<Operator>>(
      `${this.apiRoot}/${this.resource}/reject/${orderId}`,
      {},
    );
  }

  payUserInvoice(invoiceId: string) {
    return this.http.post<ApiItemResponse<Operator>>(
      `${this.apiRoot}/${this.resource}/payUserInvoice`,
      {
        invoice: invoiceId,
      },
    );
  }

  setPassword(payload: OperatorSetPasswordPayload) {
    return this.http.post<ApiItemResponse<Operator>>(
      `${this.apiRoot}/${this.resource}/setPassword`,
      payload,
    );
  }

  getDailyOrderStats(operatorId: string) {
    const params = new HttpParams()
      .set('where[operator][eq]', operatorId)
      .set('orderBy[createdAt]', 'DESC'); // DESC
    return this.http.get<any>(`${this.apiRoot}/dailyOrderStats`, { params });
  }
}
